import axios from 'axios';
import { API_URL, REFRESH_TOKEN } from '../configs/AppConfig';

// Best-effort: tells the server to end this session's refresh token, then drops it
// locally. Never blocks or fails logout.
export const revokeRefreshToken = () => {
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  if (!refreshToken) return;
  axios.post(`${API_URL}/api/auth/logout`, { refreshToken }).catch(() => {});
};
